<template>
  <el-drawer
    :visible="visible"
    size="480px"
    :with-header="false"
    append-to-body
    custom-class="lib-cart"
    @update:visible="(val) => $emit('update:visible', val)"
  >
    <div class="lib-cart__wrap">
      <header class="lib-cart__head">
        <div>
          <h3>Giỏ giao bài <span class="lib-cart__badge">{{ items.length }}</span></h3>
          <p>{{ items.length }} bài tập từ {{ groups.length }} danh mục khác nhau</p>
        </div>
        <button type="button" class="lib-cart__close" @click="$emit('update:visible', false)">
          <i class="el-icon-close"></i>
        </button>
      </header>

      <div class="lib-cart__body">
        <section v-for="group in groups" :key="group.key" class="lib-cart__group">
          <div class="lib-cart__group-head">
            <span class="lib-cart__group-path"><i class="el-icon-folder"></i> {{ group.label }}</span>
            <span class="lib-cart__group-meta">
              {{ group.items.length }} bài ·
              <a @click="$emit('remove', group.items)">Bỏ nhóm</a>
            </span>
          </div>
          <div v-for="item in group.items" :key="item._id" class="lib-cart__item">
            <span class="lib-cart__icon" :style="{ background: meta(item).bg, color: meta(item).color }">
              <i :class="meta(item).icon"></i>
            </span>
            <span class="lib-cart__item-text">
              <strong>{{ item.title }}</strong>
              <small>{{ meta(item).label }} · {{ item.contentCount }} {{ meta(item).unit }}</small>
            </span>
            <button type="button" class="lib-cart__remove" @click="$emit('remove', [item])">
              <i class="el-icon-close"></i>
            </button>
          </div>
        </section>
        <div v-if="!items.length" class="lib-cart__empty">Chưa chọn bài tập nào</div>
      </div>

      <footer class="lib-cart__foot">
        <div class="lib-cart__total">
          <span>Tổng cộng {{ items.length }} bài tập</span>
          <a v-if="items.length" @click="$emit('clear')">Bỏ chọn tất cả</a>
        </div>
        <el-button
          type="primary"
          class="lib-cart__submit"
          icon="el-icon-s-promotion"
          :disabled="!items.length"
          @click="$emit('assign')"
        >Tiếp tục giao bài ({{ items.length }})</el-button>
      </footer>
    </div>
  </el-drawer>
</template>

<script>
import { KIND_META, lastCategoryOf } from './kinds'

export default {
  name: 'LibraryCartDrawer',

  props: {
    visible: { type: Boolean, default: false },
    items: { type: Array, default: () => [] }
  },

  computed: {
    // Nhóm theo danh mục chứa bài, giữ thứ tự chọn
    groups() {
      const map = new Map()
      for (const item of this.items) {
        const last = lastCategoryOf(item)
        const key = last ? last._id : 'none'
        if (!map.has(key)) {
          const label = (item.categoryPath || []).map((p) => p.name).join(' › ') || 'Không có danh mục'
          map.set(key, { key, label, items: [] })
        }
        map.get(key).items.push(item)
      }
      return [...map.values()]
    }
  },

  methods: {
    meta(item) {
      return KIND_META[item.kind] || KIND_META.exercise
    }
  }
}
</script>

<style lang="scss" scoped>
$green: #1cab36;

.lib-cart {
  &__wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px 24px 16px;
    border-bottom: 1px solid #eef0ef;

    h3 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
      font-size: 20px;
    }

    p {
      margin: 4px 0 0;
      color: #6b7280;
      font-size: 13px;
    }
  }

  &__badge {
    padding: 0 8px;
    border-radius: 10px;
    background: $green;
    color: #fff;
    font-size: 12px;
    line-height: 20px;
  }

  &__close {
    width: 36px;
    height: 36px;
    border: 0;
    border-radius: 50%;
    background: #f2f4f3;
    font-size: 16px;
    cursor: pointer;
  }

  &__body {
    flex: 1;
    overflow: auto;
    padding: 16px 24px;
  }

  &__group + &__group {
    margin-top: 16px;
  }

  &__group-head {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
  }

  &__group-path {
    color: $green;
    font-weight: 600;
  }

  &__group-meta {
    flex-shrink: 0;
    color: #6b7280;

    a {
      color: #6b7280;
      cursor: pointer;

      &:hover {
        color: $green;
      }
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    margin-bottom: 6px;
    border-radius: 8px;
    background: #f7f8f7;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
  }

  &__item-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;

    strong {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
    }

    small {
      color: #6b7280;
      font-size: 12px;
    }
  }

  &__remove {
    border: 0;
    background: transparent;
    color: #374151;
    cursor: pointer;
  }

  &__empty {
    padding: 40px 0;
    text-align: center;
    color: #9ca3af;
  }

  &__foot {
    padding: 16px 24px 24px;
    border-top: 1px solid #eef0ef;
  }

  &__total {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 14px;

    a {
      color: #e0484d;
      cursor: pointer;
    }
  }

  &__submit {
    width: 100%;
    height: 46px;
    font-size: 15px;
    font-weight: 600;
  }
}
</style>
